import Input from 'element-ui/packages/input';
export default {
	extends: Input,
	props: {
		ariaControls: {
			required: false
		},
		remote: {
			required: false
		}
	},
	inheritAttrs: false
};
